export const LICENSES = "licenses";
export const LICENSE_POOLS = "license-pools";
export const SMS_CAMPAIGNS = "sms-campaigns";

export const PACKAGE_TYPES = {
  DID_REGULAR: "DID_REGULAR",
  DID_TOLLFREE: "DID_TOLLFREE",
  TRUNKS: "TRUNKS",
  VCC_SMS_CHANNELS: "VCC_SMS_CHANNELS",
};

export const LICENSES_STATUS = {
  PENDING_CONFIGURATION: "PENDING_CONFIGURATION",
};

export const PACKAGES = {
  [PACKAGE_TYPES.DID_REGULAR]: "LPFLvt_jQ82ORq00sTN7Ug",
  [PACKAGE_TYPES.DID_TOLLFREE]: "nI6eJ2jGQBimojx78WM3Hw",
  [PACKAGE_TYPES.TRUNKS]: "h12gQ6mLSA6ZUsz2slZjBg",
  [PACKAGE_TYPES.VCC_SMS_CHANNELS]: "LPFLvt_jQ82ORq00sTN7Ug",
};
